import { render } from "./CDCSensorsPage.vue?vue&type=template&id=646d73f0&scoped=true"
import script from "./CDCSensorsPage.vue?vue&type=script&lang=js"
export * from "./CDCSensorsPage.vue?vue&type=script&lang=js"

import "./CDCSensorsPage.vue?vue&type=style&index=0&id=646d73f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-646d73f0"]])

export default __exports__